module.exports = __webpack_public_path__ + "static/media/CloseCircle.19794c23.svg";